import styled from 'styled-components';
import { Theme, TextField, TextFieldProps } from '@material-ui/core';
import * as React from 'react';
import SearhIcon from '../../../../../../icons/SearchBlack';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const Icon = styled(SearhIcon)(props => ({
  width: theme(props).spacing(2),
  height: theme(props).spacing(2),
  boxSizing: 'content-box',
})) as typeof SearhIcon;

type StyledInputSearchType = React.FC<TextFieldProps & {}>;
export const StyledInputSearch = styled(TextField)(props => ({
  userSelect: "none",
  marginLeft: theme(props).spacing(1.5),
  marginRight: theme(props).spacing(1.5),
  marginTop: theme(props).spacing(1.5),
  marginBottom: theme(props).spacing(1),
  height: theme(props).spacing(4),
  paddingLeft: theme(props).spacing(2), 
  paddingRight: theme(props).spacing(2),
  background: "rgba(43, 57, 64, 0.07)",
  borderColor: "rgba(43, 57, 64, 0.07)",
  borderRadius: "3px",
  borderStyle: "solid",
  borderWidth: "1px",
  "& .hierarchy-search-input:before": {
    display: "none"
  },
  "& .hierarchy-search-input:after": {
    display: "none"
  },
  "&.focus": {
    borderColor: theme(props).palette.primary.main
  },

  "& input": {
    fontSize: '14px',
    lineHeight: '17px',
  },
})) as StyledInputSearchType;